import React from "react";
import business from '../SmcLife/Images/Business-Premium.svg';
import policies from '../SmcLife/Images/Policies-sold.svg';
import claim from '../SmcLife/Images/Claims-assisted.svg';

const OtherLink = () => {
    return (
        <div className="otherLinksSmc">
            <div className="StepsRow">
                <div className="StepsColm">
                    <img src={business} />
                    <div>
                        <b>28.84 Billion +</b> <small>Business Premium<br /></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={policies} />
                    <div>
                        <b>11 Million +</b> <small>Policies sold<br /></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={claim} />
                    <div>
                        <b>2.04 Million +</b> <small>Claims assisted<br /></small>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OtherLink;